/* global jwplayer */
import React from 'react';
import Jwplayer from './MediaPlayer/Jwplayer';
import Html5Player from './MediaPlayer/Html5Player';

export default class Vod extends React.Component {

  
  render() {
   if(window.local) 
    return (
        /*<Html5Player videoUrl="https://secure.synople.tv/mediacenter3/videos/MEDIA190122165100049/multimedia/MEDIA190122165100049.mp4" />*/
        <Html5Player videoUrl="media/video.mp4" />
      );
  else
    return (
      <Jwplayer streamingUrl={ window.vod_url } />
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Vod.js